/*** IMPORTS FROM imports-loader ***/
var define = false;

require('../../modules/es7.string.trim-right');
module.exports = require('../../modules/_core').String.trimRight;

